import { styled } from '@mui/material/styles';
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Popover,
  Select,
  StepConnector,
  stepConnectorClasses,
  Tab,
  TextField,
  Typography,
} from '@mui/material';
import { TabList } from '@mui/lab';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { lightPalette, up } from '../../../../theme';

export const classes = {
  root: 'root',
  odooPopup: 'odooPopup',
  odooPopupHeight: 'odooPopupHeight',
  odooPopupErrorHeight: 'odooPopupErrorHeight',
  secondGridBox: 'secondGridBox',
  newFlowBackdrop: 'newFlowBackdrop',
  addNewFlowButton: 'addNewFlowButton',
  cardComponent: 'cardComponent',
  CardHeader: 'CardHeader',
  CardContent: 'CardContent',
  closeAction: 'closeAction',
  actionButtonBox: 'actionButtonBox',
  cancelButton: 'cancelButton',
  saveButton: 'saveButton',
  timeRange: 'timeRange',
  flowDataGrid: 'flowDataGrid',
  buttonBox: 'buttonBox',
  button: 'button',
  iconBox: 'iconBox',
  mainIconBox: 'mainIconBox',
  textField: 'textField',
  leftBox: 'leftBox',
  logDashboardBox: 'logDashboardBox',
  iconBorder: 'iconBorder',
  border: 'border',
  squareIcon: 'squareIcon',
  logoStyle: 'logoStyle',
  tableContainer: 'tableContainer',
  squareIconSuccess: 'squareIconSuccess',
  squareIconError: 'squareIconError',
  contentBox: 'contentBox',
  gridLogData: 'gridLogData',
  gridLogTime: 'gridLogTime',
  customNodeBox: 'customNodeBox',
  handel: 'handel',
  accordion: 'accordion',
  accordionExpanded: 'accordionExpanded',
  accordionBox: 'accordionBox',
  savaChangesButton: 'savaChangesButton',
  viewLogButton: 'viewLogButton',
  flowButton: 'flowButton',
  mainBoxForInvoiceFlow: 'mainBoxForInvoiceFlow',
  toggleButton: 'toggleButton',
  textFieldPadding: 'textFieldPadding',
  dropDownBox: 'dropDownBox',
  textFieldFolderOpenIcon: 'textFieldFolderOpenIcon',
  select: 'select',
  loginButton: 'loginButton',
  loginWithGoogle: 'loginWithGoogle',
  chip: 'chip',
  gridPadding: 'gridPadding',
  deleteIcon: 'deleteIcon',
  andButton: 'andButton',
  deleteForEdge: 'deleteForEdge',
  deleteForNode: 'deleteForNode',
  leftSideBarBox: 'leftSideBarBox',
  middleContainerBox: 'middleContainerBox',
  autoCompleteMargin: 'autoCompleteMargin',
  dividerMargin: 'dividerMargin',
  table: 'table',
  tableHead: 'tableHead',
  tableHeaderCell: 'tableHeaderCell',
  tableBody: 'tableBody',
  tableRowClass: 'tableRowClass',
  tableMainContainer: 'tableMainContainer',
  logoStyleForGoogle: 'logoStyleForGoogle',
  textTransform: 'textTransform',
  runningChip: 'runningChip',
  stopChip: 'stopChip',
  chipPadding: 'chipPadding',
  tableRow: 'tableRow',
  menuBar: 'menuBar',
  expandedHeight: 'expandedHeight',
  loaderBox: 'loaderBox',
  oddoAutocomplete: 'oddoAutocomplete',
  editFlowLoaderBox: 'editFlowLoaderBox',
  noDataFound: 'noDataFound',
  selectAndAddAccountContainer: 'selectAndAddAccountContainer',
  selectAccountAutocomplete: 'selectAccountAutocomplete',
  addAccountIconBox: 'addAccountIconBox',
  addUserAccountIcon: 'addUserAccountIcon',
  deleteAccountIcon: 'deleteAccountIcon',
  statusFilterDropdown: 'statusFilterDropdown',
  addFlowAndFilterFlowDropdownGrid: 'addFlowAndFilterFlowDropdownGrid',
  mainLogsBox: 'mainLogsBox',
  leftLogsBox: 'leftLogsBox',
  backButton: 'backButton',
  rightLogsBox: 'rightLogsBox',
  actionButton: 'actionButton',
  tableContainerForLogs: 'tableContainerForLogs',
  tableHeaderForLogsDescription: 'tableHeaderForLogsDescription',
  tableHeaderForLogsTime: 'tableHeaderForLogsTime',
  tableCellContentBox: 'tableCellContentBox',
  tableCellContentBoxTypography: 'tableCellContentBoxTypography',
  selectForLogs: 'selectForLogs',
  dateTimePickerBox: 'dateTimePickerBox',
  dateTimePickerTypography: 'dateTimePickerTypography',
  connectionBoxStyle: 'connectionBoxStyle',
  connectionLogoStyle: 'connectionLogoStyle',
  filterCellBoxStyle: 'filterCellBoxStyle',
  filterPopupRootBox: 'filterPopupRootBox',
  filterButtonBoxClass: 'filterButtonBoxClass',
  filterButtonClass: 'filterButtonClass',
  editorButton: 'editorButton',
  statusLoader: 'statusLoader',
  stepperBox: 'stepperBox',
  stepper: 'stepper',
  sidebarCloseAction: 'sidebarCloseAction',
  rightContainerIconBox: 'rightContainerIconBox',
  cursorMove: 'cursorMove',
  tallyIntroductionBackdrop: 'tallyIntroductionBackdrop',
  tallyCardComponent: 'tallyCardComponent',
  tallyIpCardHeader: 'tallyIpCardHeader',
  selectOptionsMainBox: 'selectOptionsMainBox',
  selectedFlowBox: 'selectedFlowBox',
  flowSelectedTypo: 'flowSelectedTypo',
  actionIcons: 'actionIcons',
  commonExportStepper: 'commonExportStepper',
  addTaxButton: 'addTaxButton',
  deleteIconButton: 'deleteIconButton',
};

export const FilterPopup = styled(Popover)(({ theme }) => ({
  [`& .${classes.filterPopupRootBox}`]: {
    padding: '16px',
    width: '200px',
  },
  [`& .${classes.filterButtonBoxClass}`]: {
    display: 'flex',
    justifyContent: 'space-evenly',
    marginTop: theme.spacing(1.5),
  },
  [`& .${classes.filterButtonClass}`]: {
    padding: theme.spacing(0.5),
  },
}));

export const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 20,
    left: 'calc(-50% + 20px)',
    right: 'calc(50% + 20px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.primary.main,
    borderTopWidth: 0.5,
    borderRadius: 1,
    position: 'relative',
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      top: '-3.5px',
      width: '6px',
      height: '6px',
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.main,
    },
    '&::before': {
      left: '-8px',
    },
    '&::after': {
      right: '-1px',
    },
  },
}));
export const DialogHeader = styled(DialogTitle)(({ theme }) => ({
  width: '100%',
  color: theme.palette.secondaryBlack,
  background: theme.palette.japanBlush.main,
  [theme.breakpoints.up('xs')]: {
    height: '60px',
  },
  [theme.breakpoints.up('sm')]: {
    height: '60px',
  },
  [theme.breakpoints.up('md')]: {
    height: '60px',
  },
  [theme.breakpoints.up('lg')]: {
    height: '60px',
  },
  [theme.breakpoints.up('xl')]: {
    height: '70px',
  },
  [theme.breakpoints.up('xxl')]: {
    height: '70px',
  },
}));
export const StyledTabList = styled(TabList)(({ theme }) => ({
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.primary.main,
    height: '0.370vh',
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
  },
}));

export const TaxGrid = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 2,
}));

export const AddTaxButton = styled(Button)(() => ({
  padding: '6px 12px',
  backgroundColor: '#9F77EB33',
  '&:hover': {
    backgroundColor: '#9F77EB55', // Set a slightly darker background color on hover
  },
}));

export const TaxDeleteIconButton = styled(IconButton)(() => ({
  backgroundColor: '#FFFFFF',
  borderRadius: '4px',
  border: '1px solid',
  borderColor: '#2B1E5933',
  width: '39px',
  height: '39px',
  marginLeft: '2px',
}));

export const OdooIcon = styled(Box)(() => ({
  width: '40px',
  height: '40px',
}));

export const CustomFormHelperText = styled(FormHelperText)(({ theme }) => ({
  marginLeft: theme.spacing(1.5),
  color: '#d32f2f',
}));

export const CustomCloseIcon = styled(Box)(({ theme }) => ({
  position: 'absolute',
  right: 12,
  top: 20,
  color: () => theme.palette.grey[500],
  cursor: 'pointer',
}));

export const Tabs = styled(Tab)(() => ({
  fontFamily: 'Heebo',
  fontWeight: 400,
  textTransform: 'none',
  [up('xs')]: {
    padding: '18px 14px',
  },
  [up('sm')]: {
    padding: '8px 14px',
  },
  [up('md')]: {
    padding: '10px 18px',
  },
  [up('lg')]: {
    padding: '12px 22px',
  },
  [up('xl')]: {
    padding: '14px 26px',
  },
  [up('xxl')]: {
    padding: '16px 30px',
  },
}));
export const CustomGridItems = styled(Tab)(() => ({
  height: '100%',
  width: '100%',
}));

export const GridItemsTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.darkPurple.main,
  paddingBottom: theme.spacing(1),
}));

export const GridItemsTextField = styled(TextField)(({ theme }) => ({
  borderColor: theme.palette.darkPurple.lighter,
  borderRadius: '5px',
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.paperWhite.main,
  color: theme.palette.lunarBase.main,
  marginTop: 0,
  [up('xs')]: {
    width: '80px',
    height: '30px',
    margin: '3px',
  },
  [up('sm')]: {
    width: '99px',
    height: '40px',
    margin: '4px',
  },
  [up('md')]: {
    width: '110px',
    height: '40px',
    margin: '6px',
  },
  [up('lg')]: {
    width: '110px',
    height: '44px',
    margin: '7px',
  },
  [up('xl')]: {
    width: '150px',
    height: '54px',
    margin: '10px',
  },
  [up('xxl')]: {
    width: '150px',
    height: '54px',
    margin: '10px',
  },
}));

export const SaveButton = styled(Button)(() => ({
  marginTop: 0,
  [up('xs')]: {
    width: '80px',
    height: '30px',
    margin: '3px',
  },
  [up('sm')]: {
    width: '102px',
    height: '40px',
    margin: '4px',
  },
  [up('md')]: {
    width: '113px',
    height: '40px',
    margin: '6px',
  },
  [up('lg')]: {
    width: '113px',
    height: '44px',
    margin: '7px',
  },
  [up('xl')]: {
    width: '155px',
    height: '54px',
    margin: '10px',
  },
  [up('xxl')]: {
    width: '155px',
    height: '54px',
    margin: '10px',
  },
}));

export const AddTaxFieldStyledComponent = styled(Grid)(() => ({
  width: '100%',
  display: 'flex',
  [up('xs')]: {
    padding: '12px 12px 0px',
  },
  [up('sm')]: {
    padding: '14px 14px 0px',
  },
  [up('md')]: {
    padding: '16px 16px 0px',
  },
  [up('lg')]: {
    padding: '20px 20px 0px',
  },
  [up('xl')]: {
    padding: '24px 24px 0px',
  },
  [up('xxl')]: {
    padding: '32px 32px 0px',
  },
}));

export const CustomDialogContent = styled(DialogContent)(({ theme }) => ({
  width: '100%',
  height: '350px',
  // paddingLeft: '0px',
  display: 'flex',
  alignItems: 'center',
  scrollbarWidth: 'thin',
  '&::-webkit-scrollbar': {
    width: '0.4em',
  },
  '&::-webkit-scrollbar-track': {
    background: theme.palette.lunarBase.main,
    borderRadius: '5px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.lunarBase.main,
    borderRadius: '5px',
  },
  // [up('xs')]: {
  //   padding: '12px',
  // },
  // [up('sm')]: {
  //   padding: '14px',
  // },
  // [up('md')]: {
  //   padding: '16px',
  // },
  // [up('lg')]: {
  //   padding: '20px',
  // },
  // [up('xl')]: {
  //   padding: '24px',
  // },
  // [up('xxl')]: {
  //   padding: '32px',
  // },
}));
export const CustomDialogContentTax = styled(DialogContent)(({ theme }) => ({
  width: '100%',
  height: '450px',
  scrollbarWidth: 'thin',
  '&::-webkit-scrollbar': {
    width: '0.4em',
  },
  '&::-webkit-scrollbar-track': {
    background: theme.palette.lunarBase.main,
    borderRadius: '5px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.lunarBase.main,
    borderRadius: '5px',
  },
}));
export const StyledFilterPopup = styled(Dialog)(({ theme }) => ({
  '.MuiDialog-paper': {
    [up('sm')]: {
      width: '600px',
      height: '350px',
      maxWidth: '600px',
    },
    [theme.breakpoints.up('md')]: {
      width: '800px',
      height: '450px',
      maxWidth: '800px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '600px',
      height: '550px',
      maxWidth: '900px',
    },
    [theme.breakpoints.up('xl')]: {
      width: '800px',
      height: '650px',
      maxWidth: '800px',
    },
    [theme.breakpoints.up('xxl')]: {
      width: '1000px',
      height: '750px',
      maxWidth: '1000px',
    },
  },
}));

export const OdooPopup = styled(Dialog)(() => ({
  '.MuiDialog-paper': {
    [up('xs')]: {
      width: '400px',
    },
    [up('sm')]: {
      width: '450px',
    },
    [up('md')]: {
      width: '500px',
    },
    [up('lg')]: {
      width: '700px',
      maxWidth: '700px',
    },
    [up('xl')]: {
      width: '800px',
      maxWidth: '800px',
    },
    [up('xxl')]: {
      width: '900px',
      maxWidth: '900px',
    },
  },
}));

export const DialogContentScrollbar = styled(DialogContent)(({ theme }) => ({
  padding: '10px 5px',
  margin: '0px 10px',
  '.MuiDialog-paper': {
    [up('sm')]: {
      height: '320px',
    },
    [theme.breakpoints.up('md')]: {
      height: '420px',
    },
    [theme.breakpoints.up('lg')]: {
      height: '520px',
    },
    [theme.breakpoints.up('xl')]: {
      height: '620px',
    },
    [theme.breakpoints.up('xxl')]: {
      height: '720px',
    },
  },
  borderRadius: '5px',
  overflow: 'auto',
  scrollbarWidth: 'thin',
  '&::-webkit-scrollbar': {
    width: '0.4em',
  },
  '&::-webkit-scrollbar-track': {
    background: theme.palette.lunarBase.main,
    borderRadius: '5px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.lunarBase.main,
    borderRadius: '5px',
  },
}));

export const DialogActionsWithMargin = styled(DialogActions)(() => ({
  marginTop: 'auto',
}));

export const InputAdornmentStyleComponent = styled(InputAdornment)(() => ({
  width: '70px',
  backgroundColor: '#f5f5f5',
}));

export const DividerStyleComponent = styled(InputAdornment)(() => ({
  height: '50%',
  margin: '0 8px',
}));
export const InputAdornmentSelectStyleComponent = styled(InputAdornment)(
  () => ({
    width: '70px',
    backgroundColor: '#f5f5f5',
    paddingRight: 8,
    paddingLeft: 8,
  }),
);
export const AutocompleteTaxMapping = styled(Autocomplete)({
  minWidth: '10vw',
  '& .MuiAutocomplete-inputRoot': {
    maxHeight: '39px !important', // Add !important
  },
});
export const InputGroup = styled(
  OutlinedInput,
  Select,
)(() => ({
  width: '140px',
  paddingRight: '0px',
  '& input[type=number]': {
    MozAppearance: 'textfield', // Hides spinner in Firefox
  },
  '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
    {
      WebkitAppearance: 'none', // Hides spinner in Chrome, Safari, and Edge
      margin: 0,
    },
}));

export const FormControlStyledComponent = styled(FormControl)(() => ({
  minWidth: '191px',
}));

export const AndButton = styled(Button)(() => ({
  width: 'max-content',
  minWidth: '0',
  padding: '10px 0px',
}));
export const CustomDivider = styled(Divider)(({ theme }) => ({
  height: '10px',
  width: '1px',
  margin: '2px 10px',
  backgroundColor: theme.palette.secondaryBlack.main,
  opacity: '50%',
}));

export const OrButton = styled(Button)(() => ({
  padding: '0',
  margin: '0',
  minWidth: '0',
}));

export const ColoredGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.royalBlue.main,
  padding: '10px 0px',
  borderRadius: '5px',
}));
export const TallyPrimeContent = styled(Box)(({ theme }) => ({
  position: 'relative',
  height: '100%',
  width: '100%',
  [`& .${classes.tallyIntroductionBackdrop}`]: {
    color: theme.palette.secondaryWhite.main,
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: 'transparent',
  },
  [`& .${classes.tallyCardComponent}`]: {
    backgroundColor: lightPalette.secondaryWhite.main,
    borderRadius: '5px',
    overflow: 'auto',
    [up('xs')]: {
      width: '350px',
      height: '300px',
    },
    [up('sm')]: {
      width: '500px',
      height: '450px',
    },
    [up('md')]: {
      width: '550px',
      height: '500px',
    },
    [up('lg')]: {
      width: '600px',
      height: '550px',
    },
    [up('xl')]: {
      width: '700px',
      height: '650px',
    },
    [up('xxl')]: {
      width: '900px',
      height: '850px',
    },
  },
  [`& .${classes.tallyIpCardHeader}`]: {
    width: '100%',
    color: lightPalette.darkPurple.main,
    background: lightPalette.japanBlush.main,
    [up('xs')]: {
      height: '40px',
    },
    [up('sm')]: {
      height: '60px',
    },
    [up('md')]: {
      height: '60px',
    },
    [up('lg')]: {
      height: '60px',
    },
    [up('xl')]: {
      height: '80px',
    },
    [up('xxl')]: {
      height: '90px',
    },
  },
  [`& .${classes.CardContent}`]: {
    marginTop: '10px',
    width: '100%',
    [up('xs')]: {
      padding: '0px 6px',
    },
    [up('sm')]: {
      padding: '0px 9px',
    },
    [up('md')]: {
      padding: '0px 14px',
    },
    [up('lg')]: {
      padding: '0px 18px',
    },
    [up('xl')]: {
      padding: '0px 22px',
    },
    [up('xxl')]: {
      padding: '0px 30px',
    },
  },
  [`& .${classes.closeAction}`]: {
    cursor: 'pointer',
    [up('xs')]: {
      width: '16px',
      height: '16px',
    },
    [up('sm')]: {
      width: '16px',
      height: '16px',
    },
    [up('md')]: {
      width: '18px',
      height: '18px',
    },
    [up('lg')]: {
      width: '20px',
      height: '20px',
    },
    [up('xl')]: {
      width: '22px',
      height: '22px',
    },
    [up('xxl')]: {
      width: '22px',
      height: '22px',
    },
  },
}));
export const Loader = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(255, 255, 255, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1,
}));
export const StyledHelpIcon = styled(HelpOutlineOutlinedIcon)(() => ({
  fontSize: '18px !important',
  color: 'gray',
  marginLeft: '5px',
  // marginTop: '3px',
  cursor: 'pointer',
}));

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    padding: `${theme.spacing(2.5)}`,
    [up('xs')]: {
      height: `calc(100vh - ${theme.spacing(6)});`,
    },
    overflow: 'auto',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      background: theme.palette.lunarBase.main,
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.lunarBase.main,
      borderRadius: '5px',
    },
  },
  [`& .${classes.secondGridBox}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  [`& .${classes.menuBar}`]: {
    boxShadow: 'none',
    border: '1px solid #e0e0e0',
  },
  [`& .${classes.newFlowBackdrop}`]: {
    color: theme.palette.secondaryWhite.main,
    zIndex: theme.zIndex.drawer + 1,
  },
  [`& .${classes.addNewFlowButton}`]: {
    background: theme.palette.primary.main,
    color: theme.palette.secondaryWhite.main,
    ':hover': {
      background: theme.palette.primary.main,
      color: theme.palette.secondaryWhite.main,
    },
    [up('xs')]: {
      width: '80px',
      height: '25px',
    },
    [up('sm')]: {
      width: '90px',
      height: '30px',
    },
    [up('md')]: {
      width: '95px',
      height: '30px',
    },
    [up('lg')]: {
      width: '100px',
      height: '35px',
    },
    [up('xl')]: {
      width: '115px',
      height: '40px',
    },
    [up('xxl')]: {
      width: '125px',
      height: '45px',
    },
  },
  [`& .${classes.statusFilterDropdown}`]: {
    width: '8vw',
    [up('xs')]: {
      height: '25px',
    },
    [up('sm')]: {
      height: '30px',
    },
    [up('md')]: {
      height: '30px',
    },
    [up('lg')]: {
      height: '35px',
    },
    [up('xl')]: {
      height: '40px',
    },
    [up('xxl')]: {
      height: '45px',
    },
  },
  [`& .${classes.cardComponent}`]: {
    borderRadius: '5px',
    [up('xs')]: {
      width: '295px',
    },
    [up('sm')]: {
      width: '410px',
    },
    [up('md')]: {
      width: '425px',
    },
    [up('lg')]: {
      width: '500px',
    },
    [up('xl')]: {
      width: '530px',
    },
    [up('xxl')]: {
      width: '650px',
    },
  },
  [`& .${classes.rightContainerIconBox}`]: {
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.CardHeader}`]: {
    width: '100%',
    color: theme.palette.darkPurple.main,
    background: theme.palette.japanBlush.main,
    [up('xs')]: {
      height: '40px',
    },
    [up('sm')]: {
      height: '60px',
    },
    [up('md')]: {
      height: '60px',
    },
    [up('lg')]: {
      height: '60px',
    },
    [up('xl')]: {
      height: '80px',
    },
    [up('xxl')]: {
      height: '90px',
    },
  },
  [`& .${classes.addFlowAndFilterFlowDropdownGrid}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
  },
  [`& .${classes.CardContent}`]: {
    marginTop: '10px',
    width: '100%',
    [up('xs')]: {
      padding: '6px',
    },
    [up('sm')]: {
      padding: '9px',
    },
    [up('md')]: {
      padding: '14px',
    },
    [up('lg')]: {
      padding: '18px',
    },
    [up('xl')]: {
      padding: '22px',
    },
    [up('xxl')]: {
      padding: '30px',
    },
  },
  [`& .${classes.closeAction}`]: {
    cursor: 'pointer',
    [up('xs')]: {
      width: '10px',
      height: '10px',
    },
    [up('sm')]: {
      width: '12px',
      height: '12px',
    },
    [up('md')]: {
      width: '14px',
      height: '14px',
    },
    [up('lg')]: {
      width: '16px',
      height: '16px',
    },
    [up('xl')]: {
      width: '18px',
      height: '18px',
    },
    [up('xxl')]: {
      width: '20px',
      height: '20px',
    },
  },
  [`& .${classes.selectAndAddAccountContainer}`]: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '1vh',
  },
  [`& .${classes.addAccountIconBox}`]: {
    cursor: 'pointer',
  },
  [`& .${classes.addUserAccountIcon}`]: {
    marginLeft: '10px',
    marginTop: '2px',
    cursor: 'pointer',
    [up('xs')]: {
      width: '10px',
      height: '10px',
    },
    [up('sm')]: {
      width: '12px',
      height: '12px',
    },
    [up('md')]: {
      width: '14px',
      height: '14px',
    },
    [up('lg')]: {
      width: '16px',
      height: '16px',
    },
    [up('xl')]: {
      width: '18px',
      height: '18px',
    },
    [up('xxl')]: {
      width: '20px',
      height: '20px',
    },
  },
  [`& .${classes.deleteAccountIcon}`]: {
    marginLeft: '10px',
    marginBottom: '2px',
    cursor: 'pointer',
    [up('xs')]: {
      width: '10px',
      height: '10px',
    },
    [up('sm')]: {
      width: '12px',
      height: '12px',
    },
    [up('md')]: {
      width: '14px',
      height: '14px',
    },
    [up('lg')]: {
      width: '16px',
      height: '16px',
    },
    [up('xl')]: {
      width: '18px',
      height: '18px',
    },
    [up('xxl')]: {
      width: '20px',
      height: '20px',
    },
  },
  [`& .${classes.selectAccountAutocomplete}`]: {
    flexGrow: 1,
  },
  [`& .${classes.actionButtonBox}`]: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    [up('xs')]: {
      height: '35px',
      marginTop: '10px',
    },
    [up('sm')]: {
      height: '50px',
      marginTop: '14px',
    },
    [up('md')]: {
      height: '54px',
      marginTop: '16px',
    },
    [up('lg')]: {
      height: '56px',
      marginTop: '20px',
    },
    [up('xl')]: {
      height: '60px',
      marginTop: '20px',
    },
    [up('xxl')]: {
      height: '60px',
      marginTop: '30px',
    },
  },
  [`& .${classes.cancelButton}`]: {
    backgroundColor: theme.palette.paperWhite.main,
    color: theme.palette.lunarBase.main,
    marginTop: 0,
    [up('xs')]: {
      width: '80px',
      height: '30px',
      margin: '3px',
    },
    [up('sm')]: {
      width: '99px',
      height: '40px',
      margin: '4px',
    },
    [up('md')]: {
      width: '110px',
      height: '40px',
      margin: '6px',
    },
    [up('lg')]: {
      width: '110px',
      height: '44px',
      margin: '7px',
    },
    [up('xl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
    [up('xxl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
  },
  [`& .${classes.saveButton}`]: {
    marginTop: 0,
    [up('xs')]: {
      width: '80px',
      height: '30px',
      margin: '3px',
    },
    [up('sm')]: {
      width: '99px',
      height: '40px',
      margin: '4px',
    },
    [up('md')]: {
      width: '110px',
      height: '40px',
      margin: '6px',
    },
    [up('lg')]: {
      width: '110px',
      height: '44px',
      margin: '7px',
    },
    [up('xl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
    [up('xxl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
  },
  [`& .${classes.iconBox}`]: {
    padding: '5px',
    display: 'flex',
    justifyContent: 'center',
    [up('xs')]: {
      height: '28px',
      width: '28px',
    },
    [up('sm')]: {
      height: '28px',
      width: '28px',
    },
    [up('md')]: {
      height: '32px',
      width: '33px',
    },
    [up('lg')]: {
      height: '38px',
      width: '43px',
    },
    [up('xl')]: {
      height: '38px',
      width: '43px',
    },
    [up('xxl')]: {
      height: '38px',
      width: '43px',
    },
  },
  [`& .${classes.squareIconSuccess}`]: {
    color: theme.palette.colorGreen.main,
    [up('xs')]: {
      width: '34px',
      height: '15px',
    },
    [up('sm')]: {
      width: '34px',
      height: '15px',
    },
    [up('md')]: {
      width: '34px',
      height: '15px',
    },
    [up('lg')]: {
      width: '30px',
      height: '15px',
    },
    [up('xl')]: {
      width: '39px',
      height: '18px',
    },
    [up('xxl')]: {
      width: '51px',
      height: '24px',
    },
  },

  [`& .${classes.squareIconError}`]: {
    color: theme.palette.colorRed.main,
    [up('xs')]: {
      width: '34px',
      height: '15px',
    },
    [up('sm')]: {
      width: '34px',
      height: '15px',
    },
    [up('md')]: {
      width: '34px',
      height: '15px',
    },
    [up('lg')]: {
      width: '30px',
      height: '15px',
    },
    [up('xl')]: {
      width: '39px',
      height: '18px',
    },
    [up('xxl')]: {
      width: '51px',
      height: '24px',
    },
  },
  [`& .${classes.logoStyle}`]: {
    width: '24px',
    height: '24px',
  },
  [`& .${classes.connectionLogoStyle}`]: {
    width: '20px',
    height: '20px',
  },
  [`& .${classes.contentBox}`]: {
    borderBottom: `1px solid ${theme.palette.secondaryBlack.main}`,
    paddingBottom: '10px',
  },
  [`& .${classes.textField}`]: { width: '100%' },
  [`& .${classes.border}`]: {
    borderRight: `1px solid ${theme.palette.lunarBase.medium}`,
  },
  [`& .${classes.squareIcon}`]: {
    borderTop: `1px solid ${theme.palette.lunarBase.main}`,
    borderLeft: `1px solid ${theme.palette.lunarBase.main}`,
    overflow: 'auto',
    // maxHeight: '76vh',
    [up('xs')]: {
      maxHeight: '76vh',
    },
    [up('sm')]: {
      maxHeight: '80vh',
    },
    [up('md')]: {
      maxHeight: '80vh',
    },
    [up('lg')]: {
      maxHeight: '80vh',
    },
    [up('xl')]: {
      maxHeight: '84vh',
    },
    [up('xxl')]: {
      maxHeight: '84vh',
    },
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      background: '#D9D9D9',
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#868686',
      borderRadius: '5px',
    },
  },
  [`& .${classes.gridLogData}`]: { paddingLeft: '8px' },
  [`& .${classes.gridLogTime}`]: { paddingLeft: '50px' },
  [`& .${classes.leftBox}`]: { padding: '16px' },
  [`& .${classes.mainIconBox}`]: {
    display: 'flex',
    alignItems: 'center',
    borderLeft: `1px solid ${theme.palette.lunarBase.dark}`,
  },
  [`& .${classes.iconBorder}`]: {
    borderRight: `1px solid ${theme.palette.secondaryBlack.medium}`,
  },
  [`& .${classes.buttonBox}`]: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '40px',
  },
  [`& .${classes.button}`]: {
    display: 'flex',
    justifyContent: 'center',
    [up('xs')]: {
      width: '115px',
      height: '30px',
    },
    [up('sm')]: {
      width: '115px',
      height: '30px',
    },
    [up('md')]: {
      width: '125px',
      height: '34px',
    },
    [up('lg')]: {
      width: '140px',
      height: '40px',
    },
    [up('xl')]: {
      width: '155px',
      height: '47px',
    },
    [up('xxl')]: {
      width: '194px',
      height: '54px',
    },
  },

  [`& .${classes.tableContainer}`]: {
    [up('xs')]: {
      height: '83vh',
    },
    [up('sm')]: {
      height: '68vh',
    },
    [up('md')]: {
      height: '65vh',
    },
    [up('lg')]: {
      height: '68vh',
    },
    [up('xl')]: {
      height: '75vh',
    },
    [up('xxl')]: {
      height: '78vh',
    },
  },
  [`& .${classes.customNodeBox}`]: {
    width: '52px',
    height: '52px',
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.lighter,
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  [`& .${classes.handel}`]: {
    background: theme.palette.secondaryWhite.main,
    borderRadius: '50%',
    height: '12px',
    width: '12px',
    border: '1px solid theme.palette.primary.main',
  },
  [`& .${classes.flowEditorButtons}`]: {
    margin: '10px',
    padding: '4px 8px',
  },
  [`& .${classes.accordion}`]: {
    '&.Mui-expanded': {
      margin: '0', // Setting margin to 0 for the expanded state
    },
  },
  [`& .${classes.accordionExpanded}`]: {
    '&.Mui-expanded': {
      margin: '0',
    },
  },
  [`& .${classes.textTransform}`]: {
    textTransform: 'none',
  },
  [`& .${classes.accordionBox}`]: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
    position: 'relative',
  },
  [`& .${classes.savaChangesButton}`]: {
    padding: '4px 8px',
  },
  [`& .${classes.viewLogButton}`]: {
    padding: '4px 8px',
    marginRight: theme.spacing(0.5),
  },
  [`& .${classes.flowButton}`]: {
    padding: '4px 8px',
    [up('xs')]: {
      width: '100px',
    },
    [up('md')]: {
      width: '95px',
    },
    [up('lg')]: {
      width: '100px',
    },
    [up('xl')]: {
      width: '120px',
    },
    [up('xxl')]: {
      width: '130px',
    },
  },

  [`& .${classes.mainBoxForInvoiceFlow}`]: {
    display: 'flex',
    flexGrow: 1,
    border: `1px solid ${theme.palette.lunarBase.medium}`,
    borderRadius: '5px',
    height: '100%',
  },
  [`& .${classes.toggleButton}`]: {
    minWidth: 0,
    marginBottom: '5px',
    height: '30px',
    width: '30px',
  },
  [`& .${classes.textFieldPadding}`]: {
    padding: '8px',
  },
  [`& .${classes.textFieldFolderOpenIcon}`]: {
    marginTop: '1vh',
  },
  [`& .${classes.select}`]: {
    marginTop: '10px',
    minWidth: '100x',
    width: '100%',
  },

  [`& .${classes.deleteIcon}`]: {
    width: '100%',
    height: '100%',
  },
  [`& .${classes.loginWithGoogle}`]: {
    backgroundColor: 'background.paper',
    color: theme.palette.secondaryWhite.main,
    textTransform: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    height: '45px',
    justifyContent: 'flex-start',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
    [up('xs')]: {
      width: '83vh',
    },
    [up('sm')]: {
      width: '175px',
    },
    [up('md')]: {
      width: '165px',
    },
    [up('lg')]: {
      width: '175px',
    },
    [up('xl')]: {
      width: '195px',
    },
    [up('xxl')]: {
      width: '210px',
    },
  },

  [`& .${classes.loginButton}`]: {
    marginTop: '20px',
    backgroundColor: 'background.paper',
    display: 'flex',
    alignItems: 'center',
    width: '225px',
    gap: '10px',
    height: '45px',
    justifyContent: 'flex-start',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  [`& .${classes.dropDownBox}`]: {
    overflowY: 'auto',
    overflowX: 'hidden',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      background: theme.palette.lunarBase.main,
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.lunarBase.main,
      borderRadius: '5px',
    },
  },
  [`& .${classes.andButton}`]: {
    width: 'max-content',
    minWidth: '0',
    padding: '10px 0px',
  },
  [`& .${classes.deleteForEdge}`]: {
    width: 20,
    height: 20,
  },
  [`& .${classes.deleteForNode}`]: {
    width: '100%',
    height: '100%',
  },
  [`& .${classes.logoStyleForGoogle}`]: {
    width: '192px',
    height: '192px',
  },
  [`& .${classes.chipPadding}`]: {
    padding: '0 4px',
  },
  [`& .${classes.stopChip}`]: {
    backgroundColor: theme.palette.colorRed.light,
    border: theme.palette.colorRed.dark,
  },
  [`& .${classes.runningChip}`]: {
    backgroundColor: theme.palette.colorGreen.light,
    border: theme.palette.colorGreen.dark,
  },
  [`& .${classes.leftSideBarBox}`]: {
    borderRight: `1px solid ${theme.palette.lunarBase.medium}`,
    transition: 'width 0.3s',
    height: '100%',
    overflow: 'auto',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      background: theme.palette.lunarBase.main,
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.lunarBase.main,
      borderRadius: '5px',
    },
  },
  [`& .${classes.middleContainerBox}`]: {
    flexGrow: 1,
    background: `1px solid ${theme.palette.lunarBase.main}`,
    position: 'relative',
    overflow: 'auto',
    borderTop: 'none',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      background: theme.palette.lunarBase.main,
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.lunarBase.main,
      borderRadius: '5px',
    },
  },
  [`& .${classes.autoCompleteMargin}`]: { marginTop: '16px' },
  [`& .${classes.dividerMargin}`]: { marginTop: '16px' },
  [`& .${classes.table}`]: {
    border: `1px solid ${theme.palette.lunarBase.medium}`,
    borderTop: 'none',
    borderBottom: 'none',
  },
  [`& .${classes.tableHead}`]: {
    background: theme.palette.lunarBase.main,
  },
  [`& .${classes.tableHeaderCell}`]: {
    background: theme.palette.japanBlush.main,
    color: theme.palette.darkPurple.main,
    fontFamily: 'Heebo',
    fontWeight: 500,
    [up('xs')]: {
      fontSize: '10px',
    },
    [up('sm')]: {
      fontSize: '11px',
    },
    [up('md')]: {
      fontSize: '11px',
    },
    [up('lg')]: {
      fontSize: '12px',
    },
    [up('xl')]: {
      fontSize: '14px',
    },
    [up('xxl')]: {
      fontSize: '16px',
    },
  },
  [`& .${classes.tableBody}`]: {
    height: '200px',
    paddingTop: '48px',
  },
  [`& .${classes.tableRowClass}`]: {
    '&:hover': {
      backgroundColor: theme.palette.primary.lighter, // Adjust the color as needed
    },
  },
  [`& .${classes.tableMainContainer}`]: {
    maxHeight: `calc(100vh - 145px)`,

    // [up('xs')]: {
    //   maxHeight: '83vh',
    // },
    // [up('sm')]: {
    //   maxHeight: '82vh',
    // },
    // [up('md')]: {
    //   maxHeight: '84vh',
    // },
    // [up('lg')]: {
    //   maxHeight: '81vh',
    // },
    // [up('xl')]: {
    //   maxHeight: '83vh',
    // },
    // [up('xxl')]: {
    //   maxHeight: '83vh',
    // },
    borderRadius: '5px',
    border: `1px solid ${theme.palette.secondaryBlack.lighter}`,
    overflow: 'auto',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      background: theme.palette.lightSilver.main,
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.lunarBase.main,
      borderRadius: '5px',
    },
  },

  [`& .${classes.tableRow}`]: {
    borderTop: `1px solid ${theme.palette.lunarBase.medium}`,
    overflow: 'auto',
    maxHeight: '500px',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      background: theme.palette.lunarBase.main,
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.lunarBase.main,
      borderRadius: '5px',
    },
  },
  [`& .${classes.loaderBox}`]: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 'modal',
  },
  [`& .${classes.expandedHeight}`]: {
    [up('xs')]: {
      height: '83vh',
    },
    [up('sm')]: {
      height: '75%',
    },
    [up('md')]: {
      height: '76%',
    },
    [up('lg')]: {
      height: '79%',
    },
    [up('xl')]: {
      height: '83%',
    },
  },
  [`& .${classes.oddoAutocomplete}`]: {
    marginTop: '4px',
  },
  [`& .${classes.editFlowLoaderBox}`]: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  [`& .${classes.noDataFound}`]: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },

  [`& .${classes.mainLogsBox}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  [`& .${classes.leftLogsBox}`]: {
    display: 'flex',
    alignItems: 'center',
    width: '20%',
  },
  [`& .${classes.backButton}`]: {
    padding: '6px 8px',
    display: 'flex',
    alignItems: 'center',
    marginRight: '5px',
  },
  [`& .${classes.rightLogsBox}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '80%',
    gap: 1.5,
  },
  [`& .${classes.actionButton}`]: {
    padding: '8px 5px',
    minWidth: '40px',
  },
  [`& .${classes.tableContainerForLogs}`]: {
    marginTop: '15px',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      background: '#D9D9D9',
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#868686',
      borderRadius: '5px',
    },
    maxHeight: `calc(100vh - 165px)`,
    //   maxHeight: '500px',
    // },
    // [up('sm')]: {
    //   maxHeight: '500px',
    // },
    // [up('md')]: {
    //   maxHeight: '600px',
    // },
    // [up('lg')]: {
    //   maxHeight: '620px',
    // },
    // [up('xl')]: {
    //   maxHeight: '640px',
    // },
    // [up('xxl')]: {
    //   maxHeight: '800px',
    // },
  },
  [`& .${classes.tableHeaderForLogsDescription}`]: {
    backgroundColor: lightPalette.pastelLavender.main,
    alignItems: 'left',
    // [up('xs')]: {
    //   width: '80%',
    // },
    [up('sm')]: {
      width: '85%',
    },
    [up('md')]: {
      width: '78%',
    },
    [up('lg')]: {
      width: '85%',
    },
  },
  [`& .${classes.tableHeaderForLogsTime}`]: {
    backgroundColor: lightPalette.pastelLavender.main,
    alignItems: 'left',
    // [up('xs')]: {
    //   width: '20%',
    // },
    [up('sm')]: {
      width: '15%',
    },
    [up('md')]: {
      width: '18%',
    },
    [up('lg')]: {
      width: '15%',
    },
  },
  [`& .${classes.tableCellContentBox}`]: {
    display: 'flex',
    gap: 1.5,
  },
  [`& .${classes.tableCellContentBoxTypography}`]: {
    overflowWrap: 'anywhere',
  },
  [`& .${classes.selectForLogs}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [up('xs')]: {
      width: '100px',
    },
    [up('sm')]: {
      width: '150px',
    },
    [up('md')]: {
      width: '150px',
    },
    [up('lg')]: {
      width: '170px',
    },
    [up('xl')]: {
      width: '200px',
    },
    [up('xxl')]: {
      width: '200px',
    },
  },
  [`& .${classes.dateTimePickerBox}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  [`& .${classes.dateTimePickerTypography}`]: {
    margin: '0px 5px',
  },
  [`& .${classes.connectionBoxStyle}`]: {
    background: theme.palette.primary.lighter,
    padding: '8px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.filterCellBoxStyle}`]: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  [`& .${classes.editorButton}`]: {
    background: theme.palette.primary.lighter,
    '&:hover': {
      background: theme.palette.primary.lighter,
    },
  },
  [`& .${classes.statusLoader}`]: {
    marginLeft: theme.spacing(1.5),
  },
  [`& .${classes.stepperBox}`]: {
    width: '25vw',
  },
  [`& .${classes.stepper}`]: {
    padding: 0,
    margin: 0,
    width: '100%',
    '& .MuiStep-root': { padding: 0, margin: 0 },
    '& .MuiStepLabel-root': { margin: 0, padding: 0 },
  },
  [`& .${classes.sidebarCloseAction}`]: {
    cursor: 'pointer',
    [up('xs')]: {
      width: '10px',
      height: '10px',
    },
    [up('sm')]: {
      width: '12px',
      height: '12px',
    },
    [up('md')]: {
      width: '14px',
      height: '14px',
    },
    [up('lg')]: {
      width: '16px',
      height: '16px',
    },
    [up('xl')]: {
      width: '18px',
      height: '18px',
    },
    [up('xxl')]: {
      width: '20px',
      height: '20px',
    },
  },
  [`& .${classes.cursorMove}`]: {
    cursor: 'Move',
  },
  [`& .${classes.selectOptionsMainBox}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  [`& .${classes.selectedFlowBox}`]: {
    marginBottom: '5px',
    padding: '5px',
    display: 'flex',
    backgroundColor: 'background.paper',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.5)',
  },
  [`& .${classes.flowSelectedTypo}`]: {
    marginRight: '1vw',
  },
  [`& .${classes.actionIcons}`]: {
    marginRight: '1vw',
    cursor: 'pointer',
    [up('xs')]: {
      width: '12',
      height: '12px',
    },
    [up('sm')]: {
      width: '14',
      height: '14px',
    },
    [up('md')]: {
      width: '16',
      height: '16px',
    },
    [up('lg')]: {
      width: '18',
      height: '18px',
    },
    [up('xl')]: {
      width: '20',
      height: '20px',
    },
    [up('xxl')]: {
      width: '22',
      height: '22px',
    },
  },
  [`& .${classes.commonExportStepper}`]: {
    marginTop: '2px',
  },

  [`& .${classes.deleteIconButton}`]: {
    backgroundColor: '#FFFFFF', // Light gray background
    borderRadius: '4px',
    border: '1px solid', // Square shape
    borderColor: '#2B1E5933',
    width: '36px', // Set width to make it square
    height: '36px', // Set height to make it square
    marginLeft: '8px', // Add spacing from TextField
  },
}));
